export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/ThankYouImage.f1c92324.svg","height":170,"width":351,"blurWidth":0,"blurHeight":0};